<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline" v-if="!queryParam.id">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="姓名">
              <a-input v-model="queryParam.name" placeholder="请输入姓名" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="手机号">
              <a-input v-model="queryParam.cellphone" placeholder="请输入手机号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="2" :xs="6">
            <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
          </a-col>
          <a-col :md="2" :xs="6">
            <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
          </a-col>
          <a-col :md="2" :xs="6" v-if="false">
            <a-button type="primary" icon="export" @click="handleExport">导出</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :pageNum="pageNum"
      :data="loadData"
      :scroll="{ x: 1000 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="user_department" slot-scope="text">
        <a-tag v-for="(d, index) in text" :key="index">
          {{ d }}
        </a-tag>
      </div>
      <div slot="user_role" slot-scope="text">
        <a-tag v-for="(d, index) in decodeRoles(text)" :key="index">
          {{ d['name'] }}
        </a-tag>
      </div>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleUserDepartment(record)">关联部门</a>
              </a-menu-item>
              <a-menu-item v-if="false">
                <a @click="handleRelatedRole(record)">关联角色</a>
              </a-menu-item>
              <a-menu-item v-if="false">
                <a @click="handleRelatedContract(record)">关联合同</a>
              </a-menu-item>
              <a-menu-item v-if="false">
                <a @click="handleRelatedRank(record)">关联职级</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <user-department-form
      ref="createUserDepartmentModal"
      :visible="userDepartmentVisible"
      v-if="userDepartmentVisible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleUserDepartmentCancel"
      @ok="handleUserDepartmentOk"
    />
    <user-role-form
      ref="createUserRoleModal"
      :visible="userRoleVisible"
      v-if="userRoleVisible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleUserRoleCancel"
      @ok="handleUserRoleOk"
    />
    <user-contract-form
      ref="readUserContractModal"
      :visible="userContractVisible"
      v-if="userContractVisible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleUserContractCancel"
      @ok="handleUserContractOk"
    />
    <user-rank-form
      ref="readUserRankModal"
      :visible="userRankVisible"
      v-if="userRankVisible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleUserRankCancel"
      @ok="handleUserRankOk"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import CreateForm from '../modules/CreateForm'
import UserDepartmentForm from '../modules/UserDepartmentForm'
import UserRoleForm from '../modules/UserRoleForm'
import UserContractForm from '../modules/UserContractForm'
import UserRankForm from '../modules/UserRankForm'

import {
  exportUser,
  tradeUserCreate,
  tradeUserDelete,
  tradeUserDepartmentCreate,
  tradeUserList, tradeUserUpdate
} from '@/api/trade_user'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm,
    UserDepartmentForm,
    UserRoleForm,
    UserContractForm,
    UserRankForm
  },
  data () {
    return {
      pageNum: 1,
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      userDepartmentVisible: false,
      userRoleVisible: false,
      userContractVisible: false,
      userRankVisible: false,
      mdl: {},
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          fixed: 'left',
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '姓名',
          dataIndex: 'name',
          width: 100,
          ellipsis: true
        },
        {
          title: '关联系统账号',
          dataIndex: 'user',
          width: 150,
          ellipsis: true
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          width: 150,
          ellipsis: true
        },
        {
          title: '手机号',
          dataIndex: 'cell_phone1',
          width: 150,
          ellipsis: true
        },
        {
          title: '备用手机号',
          dataIndex: 'cell_phone2',
          width: 150,
          ellipsis: true
        },
        {
          title: '办公地点',
          dataIndex: 'office_location',
          width: 150,
          ellipsis: true
        },
        {
          title: 'OA Code',
          dataIndex: 'oa_code',
          width: 150,
          ellipsis: true
        },
        {
          title: '金蝶编码',
          dataIndex: 'jd_code',
          width: 150,
          ellipsis: true
        },
        {
          title: '部门',
          dataIndex: 'user_department',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'user_department' }
        },
        // {
        //   title: '角色',
        //   dataIndex: 'role',
        //   width: 200,
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'user_role' }
        // },
        {
          title: '操作',
          dataIndex: 'action',
          width: 180,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }

      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return tradeUserList(Object.assign(parameter, this.queryParam))
          .then(({ data }) => {
            return data
          })
      }
    }
  },
  created () {
    this.setCurrentPage()
  },
  methods: {
    setCurrentPage () {
      // const page = sessionStorage.getItem('CurrentPage')
      const page = this.$store.getters.pop
      if (page) {
        const current = page.split('#$$#')[0]
        const query = page.split('#$$#')[1]
        const path = page.split('#$$#')[2]
        sessionStorage.removeItem('CurrentPage')
        if (path === this.$route.path) {
          if (!isNaN(Number(current))) {
            this.pageNum = Number(current)
          }
          if (query) {
            this.queryParam = JSON.parse(query)
          }
        } else {
          this.queryParam = {}
          this.$store.dispatch('clear')
        }
      }
    },
    handleAdd () {
      this.mdl = null
      this.visible = true
    },
    handleExport () {
      exportUser(this.queryParam).then(res => {
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/octet-stream' })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', `用户.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleUserDepartmentCancel () {
      this.userDepartmentVisible = false
      const form = this.$refs.createUserDepartmentModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleUserRoleCancel () {
      const form = this.$refs.createUserRoleModal.form
      form.resetFields() // 清理表单数据（可不做）
      this.userRoleVisible = false
    },
    handleUserContractCancel () {
      this.userContractVisible = false
      const form = this.$refs.readUserContractModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleUserRankCancel () {
      this.userRankVisible = false
      const form = this.$refs.readUserRankModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    handleDetail (record) {
      this.$store.dispatch('push', this.$refs.table.getCurrent() + '#$$#' + JSON.stringify(this.queryParam) + '#$$#' + this.$route.path)
      this.$router.push({ path: '/electricity_meter_record/' + record.id })
    },
    handleDelete (record) {
      tradeUserDelete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleUserDepartment (record) {
      this.mdl = record
      this.userDepartmentVisible = true
    },
    handleRelatedRole (record) {
      this.mdl = record
      this.userRoleVisible = true
    },
    handleRelatedContract (record) {
      this.mdl = record
      this.userContractVisible = true
    },
    handleRelatedRank (record) {
      this.mdl = record
      this.userRankVisible = true
    },
    handleOk () {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          // 新增
          tradeUserCreate(values).then(res => {
            this.confirmLoading = false
            if (res.code === 1000) {
              this.visible = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleUserDepartmentOk () {
      const form = this.$refs.createUserDepartmentModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          values.user_id = this.mdl.id
          tradeUserDepartmentCreate(values).then(res => {
            this.confirmLoading = false
            if (res.code === 1000) {
              this.userDepartmentVisible = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    encodeRoles (maskStrings) {
      console.log(maskStrings)
      return maskStrings.reduce((mask, str) => mask | parseInt(str, 10), 0)
    },
    decodeRoles (mask) {
      console.log('======decodeRoles====', mask)
      if (typeof mask !== 'number' || mask < 0 || !Number.isInteger(mask)) {
        console.warn('Invalid role mask:', mask)
        return []
      }

      const dict = this.$Dictionaries.trade_user_roles || {}

      // 将字典的 key 转为数字，并过滤出在 mask 中启用的角色
      return Object.keys(dict)
        .map(key => {
          const id = Number(key)
          return { id, name: dict[key] }
        })
        .filter(({ id }) => mask & id) // 按位与判断是否包含该角色
    },
    handleUserRoleOk () {
      const form = this.$refs.createUserRoleModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const role = this.encodeRoles(values['role'])
          tradeUserUpdate({ role: role }, this.mdl.id).then(res => {
            this.confirmLoading = false
            if (res.code === 1000) {
              this.userRoleVisible = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleUserContractOk () {
      this.handleUserContractCancel()
    },
    handleUserRankOk () {
      this.handleUserRankCancel()
    }
  }
}
</script>
